import styled from 'styled-components';
import { offWhite } from '@bufferapp/components/style/color';
import { Text, Button } from '@bufferapp/ui';
import {
  grayLight,
  grayDarker,
  red,
  redDark,
  grayDark,
  gray,
} from '@bufferapp/ui/style/colors';
import { fontWeightBold } from '@bufferapp/ui/style/fonts';

export const ALLOWED_COLORS = [grayDark, red];

export const CommentIconWrapper = styled.span`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  margin-left: 0.5rem;
  border-left: 1px solid ${grayLight};
  color: ${grayDarker};
`;

export const UserTagsIconWrapper = styled.span`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  color: ${grayDarker};
  ${({ hasFirstComment }) =>
    !hasFirstComment
      ? `margin-left: 0.5rem; border-left: 1px solid ${grayLight};`
      : ''}
`;

export const CardFooterWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 1rem;
  opacity: ${({ isDragging }) => (isDragging ? 0 : 1)};
  border-radius: 0 0 4px 4px;
`;

export const CardFooterWrapperWithBorder = styled(CardFooterWrapper)`
  padding: 8px 16px;
  background-color: ${offWhite};
  border-top: 1px solid ${gray};
`;

export const CardFooterContent = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  padding-right: 2rem;
`;

export const IconWrapper = styled.span`
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
`;

export const ThreadIconWrapper = styled.span`
  margin-right: 4px;
  margin-top: 2px;
  display: flex;
  align-items: center;
`;

export const Message = styled(Text)`
  font-size: 12px;
  margin: 0;
  color: ${({ textColor }) => textColor};
`;

export const ThreadCounter = styled(Text)`
  font-size: 12px;
  margin: 0 12px 0 0;
  color: ${({ textColor }) => textColor};
`;

export const PreMessage = styled(Text)`
  font-size: 12px;
  margin: 0;
  font-weight: ${fontWeightBold};
`;

export const EditButton = styled(Button)`
  margin-right: 8px;
`;

export const ButtonStyled = styled(Button)`
  margin-left: 8px;
`;

export const RequeueButton = styled(ButtonStyled)``;

export const DraftActionButton = styled(ButtonStyled)``;

export const DeleteButton = styled(Button)`
  color: ${red};
  margin-right: 8px;

  :hover {
    color: ${redDark};
  }
`;

export const ButtonWrapper = styled.span`
  display: flex;
`;
